// 基础垫片
import 'es6-promise/auto';
import 'core-js/es/map';
import 'core-js/es/set';
import 'core-js/es/string';
import 'core-js/es/object';
import 'core-js/es/array';
import 'core-js/es/reflect';

import '@chat/utils/lib/flexible';
import React from 'react';
import ReactDOM from 'react-dom';
// 运行环境检测
import { DebugEnv, isDev, isOt, isTest1, isTest2, runtimeCheck } from '@chat/utils';
// immer垫片
import { enableES5 } from 'immer';
import { Provider } from 'react-redux';
import store from '@/redux/index';
import IMServer from '@/server/imServer';
import CustomMessageServer from '@/server/CustomMessageServer';
import InitServer from '@/server/initServer';
import SDKServer from '@/server/SDKServer';
import DifyServer from '@/server/difyServer';
import EditorServer from './server/editorServer';
import App from './App';

window.react = React;
window['react-dom'] = ReactDOM;
window.IM = {};
enableES5();

runtimeCheck().then(() => {
    window.IM.store = store;
    window.IM.EditorServer = new EditorServer();
    window.IM.IMServer = new IMServer();
    window.IM.SDKServer = new SDKServer();
    window.IM.DifyServer = new DifyServer();
    window.IM.CustomMessageServer = new CustomMessageServer();
    window.IM.InitServer = new InitServer();

    if (isOt || isOt || isTest1 || isTest2 || isDev || DebugEnv.showDebug) {
        import('@/components/devtool').then((devtool) => {
            devtool.initDevtool();
        });
    }
    ReactDOM.render(
        <Provider store={store}>
            <App />
        </Provider>,
        document.getElementById('app')
    );
});
